import { getContext, setContext } from 'svelte';
import type { ApiSchemas } from '$lib/api/shopwareApi';
import type { Readable } from 'svelte/store';
import type { SupportedLocale } from '$lib/i18n/initI18n';

export interface ShopContext {
    storeContext: ApiSchemas['SalesChannelContext'];
    shopwareLanguage: {
        languageId: string;
        shopwareLanguage?: ApiSchemas['Language'];
    };
}

export type vvmProperties = 'year' | 'size' | 'taste' | 'location' | 'line' | 'type';

export type PropertiesContext = {
    [key in vvmProperties]: Property;
};

export type Property = {
    id: string;
    translations: {
        [isoCode: string]: string;
    };
    options: {
        [id: string]: {
            [isoCode: string]: string;
        };
    };
};

export const SHOP_CONTEXT_KEY = 'SHOP_CONTEXT_KEY';
export const useShopContext = () => getContext<ShopContext>(SHOP_CONTEXT_KEY);

export const PROPERTIES_CONTEXT_KEY = 'PROPERTIES_CONTEXT_KEY';
export const usePropertiesContext = () => getContext<PropertiesContext>(PROPERTIES_CONTEXT_KEY);

export const useStoreContext = () => useShopContext()?.storeContext;

export const LOCALE_CONTEXT_KEY = 'LOCALE_CONTEXT_KEY';
export const useLocaleContext = () => getContext<SupportedLocale>(LOCALE_CONTEXT_KEY);

export const LOCALE_ISO_CONTEXT_KEY = 'LOCALE_ISO_CONTEXT_KEY';
export const useLocaleISOContext = () => getContext<string>(LOCALE_ISO_CONTEXT_KEY);

const MOUSE_POSITION_CONTEXT_KEY = 'MOUSE_POSITION_CONTEXT_KEY';
export const setMousePositionContext = (position: Readable<{ x: number; y: number }>) =>
    setContext(MOUSE_POSITION_CONTEXT_KEY, position);
export const getMousePositionContext = () =>
    getContext<ReturnType<typeof setMousePositionContext>>(MOUSE_POSITION_CONTEXT_KEY);
